<style scoped lang="stylus" rel="stylesheet/stylus"></style>
<template>
	<div class="nav-bar">
		<van-nav-bar
			:title="title || $route.meta.title"
			:left-text="leftText"
			:right-text="rightText"
			:left-arrow="leftArrow"
			:border="border"
			:fixed="fixed"
			:placeholder="placeholder"
			:z-index="zIndex"
			:safe-area-inset-top="safeAreaInsetTop"
			@click-left="onClickLeft"
			@click-right="onClickRight"
		>
			<template #left>
				<slot name="left"></slot>
			</template>
			<template #title>
				<slot name="title"></slot>
			</template>
			<template #right>
				<slot name="right"></slot>
			</template>
		</van-nav-bar>
	</div>
</template>

<script>
export default {
	name: 'navBar',
	props: {
		title: {
			// 标题
			type: String,
			default: ''
		},
		leftText: {
			// 左侧文案
			type: String,
			default: ''
		},
		rightText: {
			// 右侧文案
			type: String,
			default: ''
		},
		leftArrow: {
			// 	是否显示左侧箭头
			type: Boolean,
			default: true
		},
		border: {
			// 是否显示下边框
			type: Boolean,
			default: false
		},
		fixed: {
			// 是否固定在顶部
			type: Boolean,
			default: true
		},
		placeholder: {
			// 固定在顶部时，是否在标签位置生成一个等高的占位元素
			type: Boolean,
			default: true
		},
		zIndex: {
			// 导航栏z-index
			type: [Number, String],
			default: 1
		},
		safeAreaInsetTop: {
			// 是否开启顶部安全区适配
			type: Boolean,
			default: false
		}
	},
	watch: {},
	computed: {},
	data() {
		return {}
	},
	methods: {
		onClickLeft() {
			// 点击左侧按钮时触发
			this.$router.go(-1)
		},
		onClickRight() {
			// 点击右侧按钮时触发
		}
	}
}
</script>
